import { c as _c } from "react/compiler-runtime";
import { MiniPopoverPropertiesType } from "@website/ui/mini-popover/mini-popover.types";
import pick from "lodash-es/pick";
import { MouseEvent, RefObject, useEffect, useState } from "react";
export const useShow = (properties, popoverReference) => {
  const $ = _c(23);
  const {
    id,
    animate,
    open,
    onClose
  } = properties;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [animateOpen, setAnimateOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] !== animate || $[1] !== onClose || $[2] !== open || $[3] !== popoverReference) {
    t0 = () => {
      const checkIfClickedOutside = t2 => {
        const {
          target
        } = t2;
        if (open && popoverReference.current && !popoverReference.current.contains(target as Node)) {
          onClose();
        }
      };
      if (document) {
        if (open) {
          document.addEventListener("click", checkIfClickedOutside);
          setPopoverOpen(true);
          setTimeout(() => {
            setAnimateOpen(true);
          }, 0);
        } else {
          document.removeEventListener("click", checkIfClickedOutside);
          setAnimateOpen(false);
          setTimeout(() => {
            setPopoverOpen(false);
          }, animate === "normal" ? 0 : 150);
        }
      }
      return () => {
        if (document) {
          document.removeEventListener("click", checkIfClickedOutside);
        }
      };
    };
    t1 = [animate, onClose, open, popoverReference];
    $[0] = animate;
    $[1] = onClose;
    $[2] = open;
    $[3] = popoverReference;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  let t2;
  if ($[6] !== onClose) {
    t2 = event => {
      event.stopPropagation();
      onClose();
    };
    $[6] = onClose;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onCloseButtonClick = t2;
  const stopPropagationOnModal = _temp;
  let t3;
  if ($[8] !== properties) {
    t3 = pick(properties, "aria-labelledby", "aria-describedby");
    $[8] = properties;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== id || $[11] !== t3) {
    t4 = {
      ...t3,
      "aria-modal": true,
      onClick: stopPropagationOnModal,
      role: "dialog",
      tabIndex: 0,
      id
    };
    $[10] = id;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = animate === "normal" ? 0 : 75;
  let t6;
  if ($[13] !== t5) {
    t6 = {
      timeout: t5
    };
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== onCloseButtonClick) {
    t7 = {
      onClick: onCloseButtonClick
    };
    $[15] = onCloseButtonClick;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== animateOpen || $[18] !== popoverOpen || $[19] !== t4 || $[20] !== t6 || $[21] !== t7) {
    t8 = {
      popoverProperties: t4,
      transitionProps: t6,
      closeButtonProps: t7,
      popoverOpen,
      animateOpen
    };
    $[17] = animateOpen;
    $[18] = popoverOpen;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
function _temp(event_0) {
  event_0.stopPropagation();
}